// extracted by mini-css-extract-plugin
export var downArrow = "_8h-0";
export var infoTooltipIcon = "_8h-3";
export var label = "_8h-1";
export var optionCard = "_8h-4";
export var upArrow = "_8h-2";